import React, { Children, memo, FC, ReactNode } from 'react';
import cn from 'classnames';
import { useUniqId } from '../../../hooks/useUniqId';
require("./MenuGroup.css");
var styles = {
  "Root": "MenuGroup-module-Root_3C4",
  "Heading": "MenuGroup-module-Heading_17l"
};
export const MenuGroup = /*#__PURE__*/memo(({
  children,
  className,
  heading
}) => {
  const id = useUniqId('menu-group');
  if (!children || Children.count(children) === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-labelledby": id,
    className: cn(styles.Root, className)
  }, heading && /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    id: id,
    className: styles.Heading
  }, heading), children);
});
if (process.env.NODE_ENV !== 'production') {
  MenuGroup.displayName = 'MenuGroup';
}